import { escapeRegExp } from "views/email-template-form/components/escape-regexp";

interface HighlightTextProps {
  text: string;
  query: string;
}

/**
 * Wraps every case-insensitive occurrence of `query` inside `text` in an
 * accent span. Shared by the inbox search popover and the master search
 * palette so highlighting looks identical everywhere.
 */
export const HighlightText = ({ text, query }: HighlightTextProps) => {
  if (!query.trim()) return <span>{text}</span>;

  const regex = new RegExp(`(${escapeRegExp(query)})`, "gi");
  const parts = text.split(regex);

  return (
    <span>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <span
            key={`${part}-${i}`}
            className="text-primary-500 font-semibold bg-primary-20"
          >
            {part}
          </span>
        ) : (
          <span key={`text-${i}`}>{part}</span>
        )
      )}
    </span>
  );
};
